<template>
  <div class="taxi-numbers">
    <div class="expansion-panel">
      <div
        class="expansion-panel-header number total-count"
        @click="isExpanded = !isExpanded"
      >
        Total Count {{ content ? content.length : 0 }}
        <i class="material-icons">{{
          isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"
        }}</i>
      </div>
      <!-- <div class="expansion-panel-content" v-show="isExpanded"> -->
      <div class="number" v-show="isExpanded" v-for="(registeredDriver, index) in content" :key="index">
        {{ registeredDriver }}
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.expansion-panel {
  // border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
  padding: 12px;
  padding-top: 60px;
  display: flex;
  flex-basis: 0;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
  font-size: 12pt;
  word-break: break-all;
  position: relative;

  &-header {
    background-color: #f5f5f5;
    padding: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;

    i {
      font-size: 24px;
    }
  }

  &-content {
    padding: 12px;
  }
}
.taxi-numbers {
  // padding: 12px;
  // padding-top: 60px;
  display: flex;
  flex-basis: 0;
  flex-grow: 1;
  justify-content: center;
  // align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
  font-size: 12pt;
  word-break: break-all;
  position: relative;

  &:not(:last-child) {
    border-right: 2px solid #e1e1e1;
  }

  .number {
    padding: 8px 18px;
    width: max-content;
    background: #f7f8fa;
    border: 1px solid #5f6777;
    font-size: 10pt;
    border-radius: 99px;
    max-height: 36px;

    &.total-count {
      position: absolute;
      border: 2px solid #5f6777;
      font-weight: 600;
      top: 12px;
      left: 50%;
      transform: translateX(-50%);
    }

    &.red {
      background: #f7f8fa !important;
      border: 1px solid #27a432;
      color: #27a432;
    }
  }
}
</style>
